export default {
  ok: {
    img: "asset4.png",
    offer:
      "recibimos tus datos, un representate de BBVA se pondrá en contacto con vos en los próximos días.",
    nextSteps: [
      "<strong>Un representante de BBVA se comunicará con vos</strong> para asesorarte y brindarte información respecto a la apertura de cuentas para Comercios."
    ],
    offerEmprendedor:
      "recibimos tus datos. <br> Un representante de BBVA se contactará con vos en las próximas 72 horas.",
    offerSubtitulo:
      "Queremos acompañarte con los productos que mejor se adapten a tus necesidades."
  }
};
